// =============================================================================
// src/data/manaus-cinema.ts — Quadros do Modo Cinema (animacao historica · Tela 02).
//
// Proveniencia: assets/unified-app.js DATA.cinemaYears /
//   DATA.cinemaMarkerPositions (linhas 165-203). Portado verbatim. O campo
//   `context` carrega HTML inline (<strong>) — renderizado via innerHTML no
//   original, mantido como string para paridade exata.
// =============================================================================

import type { CinemaYearsMap, CinemaMarkerPositions } from '../app/types';

/** Quadro de cada ano-eleitoral no Modo Cinema (DATA.cinemaYears). */
export const MANAUS_CINEMA_YEARS: CinemaYearsMap = {
  '2014': {
    sub: 'eleição municipal',
    month: 'outubro · 1º turno',
    context:
      'Última eleição antes da <strong>Operação Lava Jato</strong>. MDB e PT ainda dominam localmente. <strong>Amazonino Mendes</strong> (PMDB) reeleito como força regional dominante.',
    zones: {
      norte: '#639922', leste: '#E24B4A', 'centro-oeste': '#E24B4A',
      'centro-sul': '#7F77DD', oeste: '#E24B4A', sul: '#7F77DD',
    },
    stats: [
      ['MDB', '#639922', 28], ['PT', '#E24B4A', 26], ['PSDB', '#7F77DD', 19],
      ['PSD', '#378ADD', 8], ['outros', '#888780', 19],
    ],
  },
  '2016': {
    sub: 'eleição municipal',
    month: 'outubro · pós-impeachment',
    context:
      'Primeira eleição após o <strong>impeachment de Dilma</strong>. PT recua nacionalmente, MDB capitaliza no curto prazo. PSDB ainda forte no Centro-Sul.',
    zones: {
      norte: '#639922', leste: '#E24B4A', 'centro-oeste': '#639922',
      'centro-sul': '#7F77DD', oeste: '#E24B4A', sul: '#7F77DD',
    },
    stats: [
      ['MDB', '#639922', 26], ['PT', '#E24B4A', 20], ['PSDB', '#7F77DD', 18],
      ['PSD', '#378ADD', 14], ['outros', '#888780', 22],
    ],
  },
  '2018': {
    sub: 'eleição federal',
    month: 'outubro · onda bolsonaro',
    context:
      '<strong>Onda Bolsonaro</strong> nacionalmente. PSL/PL surgem fortes no Centro-Sul de classe média alta. MDB começa a desidratar. PSD se posiciona como alternativa de centro-direita.',
    zones: {
      norte: '#639922', leste: '#378ADD', 'centro-oeste': '#378ADD',
      'centro-sul': '#185FA5', oeste: '#E24B4A', sul: '#378ADD',
    },
    stats: [
      ['PSD', '#378ADD', 22], ['PL', '#185FA5', 19], ['MDB', '#639922', 17],
      ['PT', '#E24B4A', 14], ['outros', '#888780', 28],
    ],
  },
  '2020': {
    sub: 'eleição municipal',
    month: 'novembro · pandemia',
    context:
      'Pandemia COVID-19 com <strong>Manaus epicentro</strong> e crise de oxigênio. <strong>David Almeida (Avante)</strong> é eleito prefeito no 2º turno. Avante surge como força local consolidada.',
    zones: {
      norte: '#1D9E75', leste: '#1D9E75', 'centro-oeste': '#639922',
      'centro-sul': '#185FA5', oeste: '#378ADD', sul: '#378ADD',
    },
    stats: [
      ['Avante', '#1D9E75', 24], ['PL', '#185FA5', 18], ['PSD', '#378ADD', 16],
      ['MDB', '#639922', 12], ['outros', '#888780', 30],
    ],
  },
  '2022': {
    sub: 'eleição federal',
    month: 'outubro · lula eleito',
    context:
      '<strong>Lula eleito presidente</strong> nacionalmente. Em Manaus, polarização clara entre Avante (palanque local) e PL (Bolsonaro). PT segue marginal na capital amazonense.',
    zones: {
      norte: '#1D9E75', leste: '#1D9E75', 'centro-oeste': '#639922',
      'centro-sul': '#185FA5', oeste: '#E24B4A', sul: '#378ADD',
    },
    stats: [
      ['Avante', '#1D9E75', 28], ['PL', '#185FA5', 24], ['PSD', '#378ADD', 14],
      ['PT', '#E24B4A', 11], ['outros', '#888780', 23],
    ],
  },
  '2024': {
    sub: 'eleição municipal',
    month: 'outubro · reeleição almeida',
    context:
      '<strong>David Almeida (Avante) reeleito no 1º turno</strong>. PL consolida 2º lugar com Capitão Alberto Neto. MDB e PSDB praticamente desaparecem da disputa principal.',
    zones: {
      norte: '#1D9E75', leste: '#1D9E75', 'centro-oeste': '#639922',
      'centro-sul': '#185FA5', oeste: '#E24B4A', sul: '#378ADD',
    },
    stats: [
      ['Avante', '#1D9E75', 31], ['PL', '#185FA5', 27], ['PSD', '#378ADD', 13],
      ['PT', '#E24B4A', 7], ['outros', '#888780', 22],
    ],
  },
};

/** Posicao percentual do marcador na timeline do cinema (DATA.cinemaMarkerPositions). */
export const MANAUS_CINEMA_MARKER_POSITIONS: CinemaMarkerPositions = {
  '2014': 6, '2016': 26, '2018': 47, '2020': 67, '2022': 84, '2024': 96,
};
